import React, { useEffect, useState } from "react";
import "./GroupLoansTnC.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Typography } from "@mui/material";

const GroupLoansTnC = ({ selectedLoan, setSelectedView }) => {
    useEffect(()=>{

    },[]);

    return (
        <Box>
            <Box className="d-flex justify-content-between">
                <Typography
                sx={{
                    fontFamily: "'Nunito'",
                    fontStyle: "normal",
                    fontWeight: 500,
                    fontSize: "21.4825px",
                    color: "#3A3A3A",
                }}
                className=""
                >
                    Terms & Conditions
                </Typography>

                <Button
                    className="fs-size-12 paiy-blue text-white"
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        setSelectedView(null);
                    }}
                >
                    Return
                </Button>
            </Box>
        </Box>
    )
}

export default GroupLoansTnC;
